import React, { createContext, useContext, useState, useEffect } from 'react';
import { CategoryInsightsSettingsContext } from 'contexts/CategoryInsightsSettingsContext';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { getOutofPolicy } from 'utils/apiRequests';
import { getFormattedSpend } from 'utils/number';
import {
	defaultColDefination,
	initialGridData,
} from 'CategoryManagement/Explore/DetailedAnalysis/utils';

const OutofPolicySpendContext = createContext();

const spendViaText = 'spend via';
const vendorCountText = 'vendors';
const columnDefs = [
	{ headerName: 'Vendor Name', field: 'vendoR_NAME' },
	{ headerName: 'Total Spend', field: 'totalSpend' },
	{ headerName: 'AP L1Category', field: 'aP_L1Category' },
	{ headerName: 'AP L2Category', field: 'aP_L2Category' },
	{ headerName: 'AP L3Category', field: 'aP_L3Category' },
	{ headerName: 'AP L4Category', field: 'aP_L4Category' },
	{ headerName: 'Business Unit', field: 'purchasinG_GROUP' },
	{ headerName: 'Country', field: 'country' },
];

export const OutofPolicySpendProvider = ({ children }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [analysis, setAnalysis] = useState(
		`X ${spendViaText} n ${vendorCountText}`
	);
	const [gridData, setGridData] = useState(initialGridData);
	const { currentSelectCategory, dateRangeData, isFetching } = useContext(
		CategoryManagementContext
	);
	const { isSaving, selectedOption, loading: isSettingsFetching } = useContext(
		CategoryInsightsSettingsContext
	);
	const { currency } = useContext(QueryStringContext);
	const { categoryName } = currentSelectCategory;
	const { dateFrom, dateTo } = dateRangeData;

	const vendorCount = selectedOption.length;

	useEffect(
		() => {
			if (!isSaving && !isSettingsFetching && !isFetching) {
				setIsLoading(true);
				if (
					categoryName !== '' ||
					categoryName !== null ||
					categoryName !== undefined
				) {
					const payLoad = {
						categoryName: categoryName,
						dateFrom: dateFrom,
						dateTo: dateTo,
						vendorNames: selectedOption,
					};
					if (vendorCount === 0) {
						setAnalysis(`0 spend via 0 vendors.`);
						setIsLoading(false);
					} else {
						getOutofPolicy(payLoad)
							.then(response => {
								if (response.succeeded) {
									if (response.data === null) {
										setAnalysis('Vendor not present in selected category.');
										setIsLoading(false);
										setGridData(initialGridData);
										return;
									} else {
										if (response.data.length > 0) {
											const sum = response.data.reduce((acc, obj) => {
												return acc + obj.totalSpend;
											}, 0);
											const count = [
												...new Set(response.data.map(x => x.vendoR_NAME)),
											].length;
											const analysisString = `${getFormattedSpend(
												sum,
												currency
											).toUpperCase()} ${spendViaText} ${count} ${vendorCountText}`;
											const rowResult = response.data.map(x => {
												return {
													...x,
													totalSpend: getFormattedSpend(
														x.totalSpend,
														currency
													).toUpperCase(),
												};
											});
											setAnalysis(analysisString);
											setGridData(prevState => ({
												...prevState,
												rowData: rowResult,
												columnDefs: columnDefs,
												defaultColDef: defaultColDefination,
											}));
											setIsLoading(false);
										} else {
											setAnalysis('Vendor not present in selected category.');
										}
									}
								} else {
									setIsLoading(false);
								}
							})
							.catch(() => setIsLoading(false));
					}
				} else {
					setIsLoading(false);
				}
			}
		}, // eslint-disable-next-line
		[isSaving, dateRangeData, categoryName, isSettingsFetching, isFetching]
	);

	return (
		<OutofPolicySpendContext.Provider value={{ isLoading, analysis, gridData }}>
			{children}
		</OutofPolicySpendContext.Provider>
	);
};

export const useOutofPolicySpendContext = () => {
	return useContext(OutofPolicySpendContext);
};
